<template>
  <div class="page-listingStats">
 <router-link to="/" class="btn-back"><span>Back to Dashboard</span></router-link>
    <div v-if="loading">{{ loadingMessage }}<b-icon icon="arrow-clockwise" animation="spin" font-scale="4"></b-icon></div>
    <div v-else>
      <div>
        <b-row>
          <b-col col lg="7" md="6">
              <h1 class="h4 mb-3">{{ listingName }}</h1>
          </b-col>
          <b-col>
            <date-range-picker
              ref="picker"
              opens="left"
              :singleDatePicker="false"
              :timePicker="false"
              :timePicker24Hour="false"
              :showWeekNumbers="false"
              :showDropdowns="false"
              :autoApply="false"
              v-model="dateRange"
              :linkedCalendars="true"
              style="margin-bottom: 20px"
              class="float-right"
              @update="changedDates"
              >
              <template v-slot:input="picker" style="min-width: 350px;">
                  <span style="color: #005581; margin-right: 10px;"><b-icon-calendar3 /></span>
                  <span class="rangeDisplay">{{ picker.startDate.toLocaleDateString() }}</span>
                  to
                  <span class="rangeDisplay">{{ picker.endDate.toLocaleDateString() }}</span>
              </template>
            </date-range-picker>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-card-group deck>
              <b-card>
                <b-card-title><b-icon-eye /> Total Page Views</b-card-title>
                <b-card-sub-title class="mb-2">How many times your listing was viewed</b-card-sub-title>
                <div class="bigNum">{{ stats.pageviews }}</div>
                <b-card-text style="font-size: 0.8em">
                  Tip: if your total page views are much higher than your Unique Visitors it means people are coming back to your listing to view it again!
                </b-card-text>
              </b-card>
              <b-card>
                <b-card-title><b-icon-people /> Unique Visitors</b-card-title>
                <b-card-sub-title class="mb-2">How many different people viewed your listing</b-card-sub-title>
                <div class="bigNum">{{ stats.users }}</div>
                <b-card-text style="font-size: 0.8em">
                  Tip: get more visitors to your listing by <a target="_blank" href="https://gocampingamerica.com/list-with-us/enhance">enhancing your profile</a>.
                </b-card-text>
              </b-card>
            </b-card-group>
          </b-col>
        </b-row>
        <b-row style="margin-top: 20px;">
          <b-col>
            <b-card-group deck>
              <b-card>
                <b-card-title><b-icon-link45deg /> Website Clicks</b-card-title>
                <b-card-sub-title class="mb-2">How many times the website link on your listing was clicked</b-card-sub-title>
                <div class="bigNum">{{ stats.websiteclicks }}</div>
                <b-card-text style="font-size: 0.8em">
                  Tip: if you link to your listing from your website, you can help users navigate back and forth to boost your visibility.
                </b-card-text>
              </b-card>
              <b-card>
                <b-card-title><b-icon-calendar2-check /> Reservation Link Clicks</b-card-title>
                <b-card-sub-title class="mb-2">How many times the reservation link on your listing was clicked</b-card-sub-title>
                <div class="bigNum">{{ stats.bookingclicks }}</div>
                <b-card-text style="font-size: 0.8em">
                  Tip: even if you don't have a dedicated booking link, sometimes it's best to use your normal website link here to allow users to feel agency.
                </b-card-text>
              </b-card>
            </b-card-group>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import DateRangePicker from 'vue2-daterange-picker';

import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

axios.defaults.withCredentials = true;
const server = process.env.VUE_APP_API_URL;

export default {
  name: 'Listing',
  components: {
    DateRangePicker,
  },
  data() {
    return {
      dateRange: {
        startDate: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000),
        endDate: new Date(),
      },
      loading: true,
      loadingMessage: 'Loading... Please Wait...',
      listingName: 'National Association of RV Parks and Campgrounds (ARVC)',
      stats: {
        pageviews: 0,
        users: 0,
        websiteclicks: 0,
        bookingclicks: 0,
      },
      slug: null,
      show: true,
    };
  },
  methods: {
    async changedDates() {
      try {
        const start = moment(this.dateRange.startDate).format();
        const end = moment(this.dateRange.endDate).format();
        const rawListings = await axios.get(`${server}/api/listing/${this.$route.params.id}/stats?start=${start}&end=${end}`);
        if (rawListings.data.redirect) {
          window.location.href = rawListings.data.redirect;
          return;
        }
        console.log('Loading listing', rawListings.data);

        // TODO: Set slug and listingName
        this.slug = rawListings.data.slug;
        this.listingName = rawListings.data.queryResults.records[0].Park_Listing_Name__c;
        const rawStats = rawListings.data.gaResults;
        const mapped = Object.keys(rawStats).reduce((acc, key) => {
          acc[key.replace('ga:', '')] = rawStats[key];
          return acc;
        }, {});
        mapped.websiteclicks = rawListings.data.websiteClicks;
        mapped.bookingclicks = rawListings.data.reserveClicks;
        console.log(mapped);
        this.stats = mapped;

        this.loading = false;
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 200);
      } catch (err) {
        console.log({ listListingsError: err });
        this.loadingMessage = 'There was an issue pulling your listing. Please let us know so we can take a look!';
      }
    },
  },
  mounted() {
    this.$nextTick(async () => {
      this.changedDates();
    });
  },
};
</script>

<style lang="scss" scoped>
  .rangeDisplay {
    margin: 10px;
    font-weight: bold;
    color: #005581;
  }
  .bigNum {
    text-align: center;
    margin: 30px;
    font-size: 70px;
    font-weight: bold;
    color: #005581;
  }
  .card-subtitle {
    font-weight: normal;
  }
</style>
